import { db } from "../lib/firebaseApp"
import {
    doc,
    deleteDoc,
    getDocs,
    getDoc,
    setDoc,
    collection,
    addDoc,
    serverTimestamp,
    query,
    where,
    onSnapshot,
} from "firebase/firestore";


// ------------------------------------------------------------------------
/**
 * Callback that expose error object from a function
 * @callback error_callback
 * @param {Object} error
 * @param {string} error.code
 * @param {string} error.message
 * @param {string} error.detail
 */


// ------------------------------------------------------------------------
/**
 * Add new Event Document into "EVENTS" collection
 * 
 * @param {string} user_id - user id for recording creation data
 * @param {Object} data - event data (dictionary)
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {string} - event_id 
*/
export const add_Event = async (user_id, data, cb_error) => {
    console.log(data, user_id)
    try {
        const docRef = await addDoc(collection(db, "EVENTS"), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_Event:\n", error, data)
        }
        return (undefined)
    }
}


// ------------------------------------------------------------------------
/**
 * edit exixting Event Document into "EVENTS" collection
 * 
 * @param {string} user_id - user id for recording editing user
 * @param {string} event_id - firestore event id
 * @param {Object} data - event data (dictionary)
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object=} - current event data or undefined
*/
export const edit_Event = async (user_id, event_id, data, cb_error) => {
    try {
        const docRef = await setDoc(doc(db, "EVENTS", event_id), {
            ...data,
            id: event_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })
        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_Event:\n", error)
        }
        return (undefined)
    }
}

// ------------------------------------------------------------------------
/**
 * delete exixting Event Document from "EVENTS" collection
 * 
 * @param {string} event_id - firestore event id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {boolean} - true if delete successed
*/
export const delete_Event = async (event_id, cb_error) => {
    //TODO - delete subcollection data!!!
    try {
        console.log(event_id)
        const docSnap = await (getDoc(doc(db, "EVENTS", event_id)))
        if (docSnap.exists()) {
            await deleteDoc(doc(db, "EVENTS", event_id));
            return (true)
        } else {
            return (false)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> delete_Event:\n", error)
        }
        return (undefined)
    }
}


// ------------------------------------------------------------------------
/**
 * return exixting Event Document from "EVENTS" collection
 * 
 * @param {string} event_id - firestore event id
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {Object} - event data
*/
export const get_Event_byID = async (event_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "EVENTS", event_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Event_byID:\n", error)
        }
        return (undefined)
    }
}



/**
* @param {error_callback} cb_error - callback function call in case of error
* @param {boolean=} is_public - when !== undefined activate a query filter
* @return {list} list from "EVENTS" collection
*/
export const get_Event_list = async (cb_error, is_public) => {
    try {
        const event_list = []
        let q = query(collection(db, "EVENTS"))

        if (is_public !== undefined) q = query(q, where("is_public", "==", is_public), where ('is_archived', "==", false))

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const event_data = {
                ...data,
                id: doc.id,
            }
            //DEBUG: console.log(doc.id, " => ", event_data);
            event_list.push(event_data)
        });
        return (event_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Event_list:\n", error)
        }
        return ([])
    }
}


// ------------------------------------------------------------------------
/**
* @param {error_callback} cb_error - callback function call in case of error
* @return {dictionary} return document in "EVENTS" collection in form of dictionary {event_id, data}
*/
export const get_Event_dict = async (cb_error) => {
    try {
        let event_dict = {}
        const querySnapshot = await getDocs(collection(db, "EVENTS"));
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const event_data = {
                ...data,
                id: doc.id,
            }
            //DEBUG: console.log(doc.id, " => ", event_data);
            event_dict[event_data.id] = event_data
        });
        return (event_dict)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Event_dict:\n", error)
        }
        return ({})
    }
}



/**
 * Set current status for a selected event
 * status is recorded into a Document with id = "status" inside "SETTINGS" collection 
 * 
 * @param {string} event_id - firebase event id
 * @param {Object} status_data - dictionary containing event status parameters
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {boolean} - true if status update go well 
*/
export const set_event_status = async (event_id, status_data, cb_error) => {
    try {
        console.log("SET_EVENT_STATUS")
        if (event_id){

        const statusDoc = doc(db, "EVENTS", event_id, "SETTINGS", "status")

        await setDoc(statusDoc, {
            ...status_data,
            updateTimestamp: serverTimestamp(),
        })
        return (true)
        }else{
            return false
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> set_event_status:\n", error, status_data)
        }
        return (false)
    }
}




/**
 * get current status LIVE for a selected event
 * status is read LIVE from a Document with id = "status" inside "SETTINGS" collection 
 * 
 * @param {string} event_id - firebase event id
 * @param {status_callback} cb_status - callback function call everytime status change
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {function } unsubscribe function: has to be called for close LIVE listening
*/
export const get_event_status_live = async (event_id, cb_status, cb_error) => {
    try {
        console.log("GET_EVENT_STATUS_LIVE")
        const statusDoc = doc(db, "EVENTS", event_id, "SETTINGS", "status")
        
        const unsubscribe = onSnapshot(
            statusDoc,
            (snapshot) => {
                const status_data = snapshot.data();
                cb_status(status_data)
            }, (error) => {
                cb_error(error)
            })
        return (unsubscribe)

    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_event_status_live:\n", error)
        }
        return (undefined)
    }
}